module.exports = __webpack_public_path__ + "static/media/disponivel-app-store.08b9b12e.svg";